import { useState } from 'react';
import { Button } from '@/components/ui/button';
import type { FiardleGuessData } from '@/lib/api';

interface ShareButtonProps {
  guesses: FiardleGuessData[];
  gameStatus: 'won' | 'lost';
}

const emojiMap: Record<string, string> = {
  green: '🟩',
  yellow: '🟨',
  gray: '⬛',
};

export function ShareButton({ guesses, gameStatus }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const guessCount = gameStatus === 'won' ? guesses.length : 'X';
    const grid = guesses.map((g) => g.result.map((r) => emojiMap[r]).join('')).join('\n');

    const text = `Fiardle ${guessCount}/6\n\n${grid}`;

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback: do nothing
    }
  };

  return (
    <Button onClick={handleShare} data-testid="share-button">
      {copied ? 'Copied!' : 'Share'}
    </Button>
  );
}
